import { render, staticRenderFns } from "./GenerarPrograma.vue?vue&type=template&id=05009352&scoped=true&"
import script from "./GenerarPrograma.vue?vue&type=script&lang=js&"
export * from "./GenerarPrograma.vue?vue&type=script&lang=js&"
import style0 from "./GenerarPrograma.vue?vue&type=style&index=0&id=05009352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05009352",
  null
  
)

export default component.exports